//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




import Joi from "joi";
const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
    password: Joi.string().min(6).required(),
});












export default {
    data() {
        return {
            key: '',
            user : {
                username : "",
                password : ""
            },

            register : {
                username : "",
                password : "",
                confirmPassword : '',
                nama : '',
                nik : '',
                email : "",
                hp : "",
                level : 'levelUsers/20288912'
            },

            errorMessage: '',

            modalLogin : false,
            modalRegis : false,
            loading : false,
        }
    },

    methods: {
        openModal() {
            this.notify("Upss..!! 😅", 'Mohon maaf layanan belum kami aktifkan', 'warning')
        },

        routex : function(routeName){
            if (this.$store.state.CHECK_AUTH) {
                this.$router.push('/'+routeName);
            } else {
                this.modalLogin = true
            }
        },
        registrasi: function() {
            
            this.errorMessage = "";
            if (this.validUser()) {
                // Jika user sdh valid lakukan pengiriman data ke server
                const body = {
                    username: this.register.username,
                    password: this.register.password
                };
                this.signingUp = true;
                fetch(this.$store.state.url.URL_CNT_REGISTRASI+'signup', {
                    method: "POST",
                    body: JSON.stringify(this.register),
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    }
                }).then((response) => {
                    this.signingUp = false;
                    if (response.ok) {
                        this.notify("SUKSES", 'Berhasil menambahkan akun pengguna', 'success')
                        this.getView();
                        // this.$router.push('/login');
                        // return response.json();
                    }
                    else{
                    return response.json().then(error => {
                        throw new Error(error.message);
                    });

                    }
                })
                .catch((error) => {
                    setTimeout(() => {
                        this.signingUp = false;
                        this.errorMessage = error.message;
                    }, 1000);
                });

            }else{
            console.log("tidak valid");

            }

        },



        btn_login : function(){

                        this.errorMessage = '';
            if(this.validUserLogin()){
            // this.$q.notify("hi");
            // this.$store.commit("shoWNotify", 'Kiken', 'primary', 'timer');
            const body = {
                username : this.user.username,
                password : this.user.password
            }

            this.loading = true;

            fetch(this.$store.state.url.URL_APP + "auth/login", {
                method : 'POST',
                headers : {
                'content-type' : 'application/json',
                },
                body : JSON.stringify(body),
            }).then((response) => {
                
                console.log(response);
                
                    if (response.ok) {
                        return response.json();
                        this.loading = true;
                    }

                    return response.json().then(error => {
                        throw new Error(error.message);
                        this.loading = true;
                    });
                })
                .then((result) => {
                console.log("=============================");
                // console.log(result);
                // menyimpan token yang tergenerate dari server
                localStorage.token = result.token;
                localStorage.profile = JSON.stringify(result.profile);


                var profilex = result.profile
                var profile3 = profilex.profile
                this.$store.state.userx.nama = profile3.nama;
                this.$store.state.userx.email = profile3.email;
                this.$store.state.userx.hp = profile3.hp

                // console.log(profilez.des_kel)
                // this.$store.state.ID_DES_KEL = profilez.des_kel



                setTimeout(() => {
                    // this.$store.commit("hideLoading")
                    // this.$router.push('/');
                    // location.reload();
                    this.notify("SUKSES", 'Login Sukses 😁', 'success')
                    this.$store.state.CHECK_AUTH = true
                    this.loading = false;
                    this.modalLogin = false;
                }, 500);
                })
                .catch(error => {
                setTimeout(() => {
                    // this.$store.commit("hideLoading")
                    // this.errorMessage = error.message;
                    this.notify("Gagal.. 😰", error.message, 'error')
                    this.loading = false;
                }, 500);
                });;
            }

            // this.loading = !this.loading

        },

        logOut :function(){
            localStorage.removeItem("token");
            localStorage.removeItem("profile");
            this.$store.state.CHECK_AUTH = false;
            this.$store.state.userx.nama = '';
            this.$store.state.userx.email = '';
            this.$store.state.userx.hp = ''
        },

        validUser : function(){
            if (this.register.password !== this.register.confirmPassword) {
                this.errorMessage = "Password dan Confirm Password harus sama. !";
                return false;
            }
            // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
            // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
            const body = {
                username: this.register.username,
                password: this.register.password
            };
            const result = Joi.validate(body, schema);

            if (result.error === null) {
                return true;
            }
            if (result.error.message.includes("username")) {
                // jika pesan error yang dihasilkan mengandung char "username" maka
                this.errorMessage = "Username tidak valid (Min : 6 dan Max : 14 Karakter)";
            } else {
                this.errorMessage = "Password tidak valid (Min : 6 Karakter)";
                //   console.log(result.error);

            }
            return false;
        },

        validUserLogin: function(){
            const result = Joi.validate(this.user, schema);
            if (result.error === null) {
            return true;
            }
            if (result.error.message.includes("username")) {
                this.errorMessage = "Username tidak valid";
                this.notify("Gagal.. 😰", this.errorMessage, 'error')
            } else {
                this.errorMessage = "Password tidak valid";
                this.notify("Gagal.. 😰", this.errorMessage, 'error')
            }
            return false;
        },


        notify(sukses, notif, icon){
            Swal.fire(
            sukses,
            notif,
            icon,

            )
        }













    },

    mounted () {
        if (localStorage.token) {
            this.$store.state.CHECK_AUTH = true
            
        } else {
            this.$store.state.CHECK_AUTH = false
            
        }
    },

}
